import React from 'react';
import { Checkbox, Paper } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../../styles/colors';
import { AssignmentEditState } from '../state/assignment-edit.types';

const useStyles = makeStyles({
  root: {
    padding: '1.2rem',
    border: `1px solid ${colors.assignment.grey}`
  },
  title: {
    marginBottom: '.5rem'
  },
  list: {
    margin: 0,
    padding: 0,
    paddingLeft: '12px'
  },
  text: {
    color: colors.assignment.lightgrey
  },
  checkbox: {
    margin: '10px 0',
    display: 'flex',
    alignItems: 'center'
  }
});

interface AssignmentOptionsProps {
  assignment: AssignmentEditState;
  isEditMode: boolean;
  handleAssignmentEdit(data: Partial<AssignmentEditState>): void;
}

const AssignmentOptions: React.FC<AssignmentOptionsProps> = (
  props: AssignmentOptionsProps
) => {
  const classes = useStyles();
  const { assignment, handleAssignmentEdit, isEditMode } = props;

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    handleAssignmentEdit({
      [evt.target.name]: evt.target.checked
    });
  };
  const { shuffleAnswers, shuffleQuestions } = assignment;
  return (
    <Paper elevation={0} className={classes.root}>
      <Grid container>
        <Grid item className={classes.title} xs={12}>
          <h3>Assignment Options</h3>
        </Grid>
        <Grid item className={classes.checkbox} xs={12}>
          <Checkbox
            onChange={handleChange}
            name={'shuffleAnswers'}
            color={'primary'}
            disabled={!isEditMode}
            checked={Boolean(shuffleAnswers)}
          />
          &nbsp;
          <span>Shuffle Answers Option Order</span>
        </Grid>
        <Grid item className={classes.checkbox} xs={12}>
          <Checkbox
            onChange={handleChange}
            name={'shuffleQuestions'}
            color={'primary'}
            disabled={!isEditMode}
            checked={Boolean(shuffleQuestions)}
          />
          &nbsp;
          <span>Shuffle Question Order</span>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AssignmentOptions;
